'use strict';

import { getCashboxLabel } from '../../directives/cashbox-label';

function AddTransferController($scope, $mdDialog, cashboxes) {
  'ngInject';

  $scope.cashboxes = cashboxes;
  $scope.getCashboxLabel = getCashboxLabel;
  $scope.mustBeCollected = true;

  $scope.onCashboxChange = function() {};
  $scope.save = function() {
    $mdDialog.hide({
      amount: $scope.amount,
      comments: $scope.comments,
      mustBeCollected: $scope.mustBeCollected,
      dstId: $scope.cashbox.id
    });
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };
}

export default AddTransferController;
